import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { findDOMNode } from 'react-dom';
import ResizeObserver$1 from 'resize-observer-polyfill';

class ResizeObserverComponent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "resizeObserver", void 0);
    _defineProperty(this, "componentWillUnmount", () => {
      if (this.resizeObserver) {
        this.destroyResizeObserver();
      }
    });
    _defineProperty(this, "createResizeObserver", () => {
      this.resizeObserver = new ResizeObserver$1(entry => {
        const {
          onResize
        } = this.props;
        onResize && onResize(entry);
      });
      this.resizeObserver.observe(findDOMNode(this));
    });
    _defineProperty(this, "destroyResizeObserver", () => {
      this.resizeObserver && this.resizeObserver.disconnect();
      this.resizeObserver = null;
    });
  }
  componentDidMount() {
    this.createResizeObserver();
  }
  componentDidUpdate() {
    if (!this.resizeObserver && findDOMNode(this)) {
      this.createResizeObserver();
    }
  }
  render() {
    return this.props.children;
  }
}
var ResizeObserver = ResizeObserverComponent;

export { ResizeObserver as default };
